module.exports = __webpack_public_path__ + "img/TandF_logo.bd2bd492.png";